import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  display: flex;
  margin: 0 0 30px 0;
  justify-content: center;
  .CommunityCard_wrapper {
    width: 100%;
    display: flex;
    @media (min-width:768px) {
      width: 495px;
    }
  }
  .CommunityCard_inner {
    width: 100%;
    display: flex;
    background-color: #FFFFFF;
    flex-direction: column;
    @media (min-width:768px) {
      width: 100%;
      display: flex;
      background-color: #FFFFFF;
      flex-direction: row;
    }
  }
  .CommunityCard_media {
    width: 100%;
    margin: 0 25px 15px 0;
    img {
      width: 100%;
      height: auto;
    }
    @media (min-width:768px) {
      width: 175px;
      margin: 0 25px 0 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .CommunityCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 15px;
    h4 {
      color: ${colors.color5};
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      margin: 0;
    }
    h5 {
      font-weight: 300;
      font-size: 15px;
      color: ${colors.color5};
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 10px 0 10px 0;
      li {
        font-size: 14px;
        font-weight: 300;
        line-height: 1;
        margin: 0 0 5px 0;
      }
    }
    @media (min-width:768px) {
      padding: 15px 15px 15px 0;
    }
  }
  .CommunityCard_priceWrapper {
    border-top: 1px solid ${colors.color3};
    border-bottom: 1px solid ${colors.color3};
    display: flex;
    justify-content: space-between;
  }
  .CommunityCard_priceLabel {
    padding: 6px 0;
    margin: 0;
  }
  .CommunityCard_priceValue {
    padding: 5px 15px;
    background-color: rgba(220, 215, 199, 0.3);
    font-size: 19px;
    font-weight: 400;
    margin: 0;
  }
  .CommunityCard_buttonWrapper {
    display: flex;
    justify-content: center;
    margin: 0 -15px -15px -15px;
    @media (min-width: 992px) {
      margin: 0 -15px -15px 0;
      justify-content: flex-end;
    }
  }
  .CommunityCard_mapButton {
    width: 40px;
    height: 40px;
    background-color: #6C6C6C;
    background-image: url('/images/icon-map-pin-white.svg');
    background-position: center center;
    background-repeat: no-repeat;
    @media (min-width: 992px) {
      width: 40px;
      height: 40px;
    }
  }
  .CommunityCard_detailButton {
    width: calc(100% - 40px);
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: ${colors.color2};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 15px;
    @media (min-width: 992px) {
      width: 210px;
    }
  }
`;

function CommunityCard({ community }) {
  return (
    <div className={styles}>
      <div className="CommunityCard_wrapper">
        <div className="CommunityCard_inner">
          <div className="CommunityCard_media">
            <Link name="community-detail" community={community}>
              <Image
                src={get(community, 'photos[0].contentUrl')}
                alt={get(community, 'name')}
                width={400}
                height={400}
                exact
              />
            </Link>
          </div>
          <div className="CommunityCard_content">
            <h4>{get(community, 'name')}</h4>
            <h5>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</h5>
            <div className="CommunityCard_priceWrapper">
              <span className="CommunityCard_priceLabel">Priced From</span>
              <span className="CommunityCard_priceValue">{numeral(get(community, 'priceLow')).format('$0,0')}</span>
            </div>
            <ul>
              {
                get(community, 'sqftLow') &&
                get(community, 'sqftHigh') &&
                <li>
                  {numeral(get(community, 'sqftLow')).format('0,0')}
                  {' - '}
                  {numeral(get(community, 'sqftHigh')).format('0,0')}
                  {' '} SQ FT
                </li>
              }
            </ul>
            <div className="CommunityCard_buttonWrapper">
              <ActivateMapPin itemId={get(community, '_id')}>
                <div className="CommunityCard_mapButton d-lg-block d-none" />
              </ActivateMapPin>
              <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
                <div className="CommunityCard_mapButton d-lg-none d-block" />
              </a>
              <Link name="community-detail" community={community} className="CommunityCard_detailButton">Visit Community</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCard.js